module.exports = __webpack_public_path__ + "2964c66760a6c8a78f935b82d7c5d22b.svg";